import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-state",
  "use": "icon-nav-state-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-state\">\r\n<path d=\"M100,0C45,0,0,41.4,0,92.2c0,24,10,46.2,27.4,63.5c2.5,2.9,4.2,7.6,3.3,11.6L24.1,200l41.7-19.2c0.9-1,2.5-1,3.3-1h2.5\r\n\tc9.1,2.9,19.2,3.8,28.3,3.8c55,0,100-41.4,100-92.2C200,41.4,155,0,100,0z M50.1,102.3c-8.4,0-15-6.6-15-15s6.6-15,15-15\r\n\tc8.4,0,15,6.6,15,15C65.1,95.7,58.3,102.3,50.1,102.3z M100,102.3c-8.4,0-15-6.6-15-15s6.6-15,15-15s15,6.6,15,15\r\n\tC115,95.7,108.4,102.3,100,102.3z M149.9,102.3c-8.4,0-15-6.6-15-15s6.6-15,15-15c8.4,0,15,6.6,15,15\r\n\tC164.9,95.7,158.3,102.3,149.9,102.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-state.svg
// module id = pJiK
// module chunks = 13